module.exports = __webpack_public_path__ + "static/img/bg_coupon_six.9ba5a4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_six.png
// module id = DFG7
// module chunks = 0